export function TodaySummary({ summary }: {
  summary: {
    eventsAffectingToday: number;
    happeningToday: number;
    workBlocks: number;
    locations: number;
    eligibleTasks: number;
    scheduledTasks: number;
    attentionCount: number;
    blockingAttention: number;
    outstandingReset: number;
    resetSourceEvents: number;
  };
}) {
  return (
    <div className="summary-grid">
      <article><span>Events affecting today</span><strong>{summary.eventsAffectingToday}</strong><small><b>{summary.happeningToday}</b> happening today</small></article>
      <article><span>Work blocks</span><strong>{summary.workBlocks}</strong><small>Across {summary.locations} locations</small></article>
      <article><span>Eligible tasks</span><strong>{summary.eligibleTasks}</strong><small><b>{summary.scheduledTasks}</b> scheduled</small></article>
      <article className="warning-summary"><span>Needs attention</span><strong>{summary.attentionCount}</strong><small>{summary.blockingAttention} blocking service</small></article>
      <article><span>Outstanding reset</span><strong>{summary.outstandingReset}</strong><small>From {summary.resetSourceEvents} past events</small></article>
    </div>
  );
}
